<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      @if (!profile) {
        <h1 class="title">Crear {{ termKey.profilesSingular | term }}</h1>
      }
    </div>
    <div class="title-color">
      @if (profile && !previousExist) {
        <h1 class="title">Editar {{ termKey.profilesSingular | term }}</h1>
      }
    </div>
    <div class="title-color">
      @if (profile && previousExist) {
        <h1 class="title">Activar {{ termKey.profilesSingular | term }}</h1>
      }
    </div>
    <div class="form-body">
      <form [formGroup]="profileForm" (ngSubmit)="saveProfile()">
        <div class="alert alert-danger p-2 m-2">
          @if (errorMsg?.length) {
            <ul class="mb-0">
              @for (msg of errorMsg; track msg) {
                <li>{{ msg }}</li>
              }
            </ul>
          }
        </div>
        @if (previousExist && profile) {
          <div class="alert alert-warning p-2 m-2">
            El usuario: {{ profile.username }} ya existe, desea activarlo?
          </div>
        }
        <div class="line">
          <div class="form-grid cols-2">
            <mat-form-field appearance="outline">
              <mat-label>Número de documento</mat-label>
              <input
                type="text"
                matInput
                placeholder="Número de documento"
                formControlName="username"
                required
              />
              @if (profileForm.get('username')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Nombres</mat-label>
              <input
                type="text"
                matInput
                placeholder="Nombres"
                formControlName="first_name"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (profileForm.get('first_name')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Apellidos</mat-label>
              <input
                type="text"
                matInput
                placeholder="Apellidos"
                formControlName="last_name"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (profileForm.get('last_name')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Correo</mat-label>

              <input
                type="text"
                matInput
                placeholder="Correo"
                formControlName="email"
                required
              />

              @if (profileForm.get('email')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }

              @if (profileForm.get('email')?.hasError('pattern')) {
                <mat-error class="for-text text-danger"> Ingrese un correo valido </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        @if (!profile) {
          <button type="submit" class="primary-button" [disabled]="!profileForm.touched">
            <span class="button-content"> <mat-icon fontIcon="save"></mat-icon>Crear </span>
          </button>
        }
        @if (profile && !previousExist) {
          <button type="submit" class="primary-button" [disabled]="!profileForm.touched">
            <span class="button-content"><mat-icon fontIcon="save"></mat-icon>Editar</span>
          </button>
        }
        @if (profile && previousExist) {
          <button type="submit" class="primary-button" [disabled]="!profileForm.touched">
            <span class="button-content"><mat-icon fontIcon="save"></mat-icon>Activar</span>
          </button>
        }
        <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
          <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
        </button>
      </form>
    </div>
  </div>
</div>
